import {
  GET_CONTACTS,
  GET_CONTACT,
  CREATE_CONTACT,
  DELETE_CONTACT,
  RESTORE_CONTACT,
  UPDATE_CONTACT,
  RESET_CONTACTS,
  GET_CONTACT_GROUPS,
  ADD_TO_GROUP,
  REMOVE_FROM_GROUP,
  GET_CONTACT_GROUPS_COUNT,
  BULK_ADD_TO_GROUP,
  BULK_REMOVE_FROM_GROUP,
  BULK_DELETE,
  BULK_RESTORE_CONTACTS,
  MERGE_CONTACT,
  GET_COMMENTS,
  DELETE_COMMENT,
  EDIT_COMMENT,
  ADD_COMMENT,
  LOAD_CUSTOM_TABS,
  CREATE_CUSTOM_TAB,
  DELETE_CUSTOM_TAB,
  UPDATE_CUSTOM_TAB,
  BLOCK_CONTACT,
  UNBLOCK_CONTACT,
} from './types';
import * as contactSvc from 'services/contacts.service';

export const getContacts = (query, reset) => ({
  type: GET_CONTACTS,
  payload: {
    promise: contactSvc.getContacts(query),
    query,
    reset,
  },
});

export const getContact = (id, deleted) => ({
  type: GET_CONTACT,
  payload: {
    promise: contactSvc.getContactWithGroups({
      hash: id,
      load_groups: 1,
      load_group_contacts: 1,
      load_integration_profile_urls: 1,
      contact_active: deleted ? '0' : '1',
    }),
    id,
  },
});

export const resetContacts = () => ({
  type: RESET_CONTACTS,
});

export const createContact = (data) => ({
  type: CREATE_CONTACT,
  payload: {
    promise: contactSvc.createContact(data),
  },
});

export const updateContact = (id, data) => ({
  type: UPDATE_CONTACT,
  payload: {
    promise: contactSvc.updateContact(id, data),
    id,
  },
});

export const deleteContact = (id) => ({
  type: DELETE_CONTACT,
  payload: {
    promise: contactSvc.deleteContact(id),
    id,
  },
});

export const restoreContact = (id) => ({
  type: RESTORE_CONTACT,
  payload: {
    promise: contactSvc.updateContact(id, { contact_active: '1' }),
    id,
  },
});

export const blockContact = (id) => ({
  type: BLOCK_CONTACT,
  payload: {
    promise: contactSvc.updateContact(id, { contact_blocked: '1' }),
    id,
  },
});

export const unblockContact = (id) => ({
  type: UNBLOCK_CONTACT,
  payload: {
    promise: contactSvc.updateContact(id, { contact_blocked: '0' }),
    id,
  },
});

export const getContactGroups = (contactHash) => ({
  type: GET_CONTACT_GROUPS,
  payload: {
    promise: contactSvc.getGroupsForContact(contactHash),
    hash: contactHash,
  },
});

export const addToGroup = (contactHash, groupHash) => ({
  type: ADD_TO_GROUP,
  payload: {
    promise: contactSvc.addContactToGroup(contactHash, groupHash),
    contactHash,
    groupHash,
  },
});

export const removeFromGroup = (contactHash, groupHash) => ({
  type: REMOVE_FROM_GROUP,
  payload: {
    promise: contactSvc.removeContactFromGroup(contactHash, groupHash),
    groupHash,
    contactHash,
  },
});

export const getContactGroupsCount = (contactId) => ({
  type: GET_CONTACT_GROUPS_COUNT,
  payload: {
    promise: contactSvc.getContactGroupCount(contactId),
    id: contactId,
  },
});

export const bulkAddToGroup = (ids, groupHash) => ({
  type: BULK_ADD_TO_GROUP,
  payload: {
    promise: contactSvc.bulkAddToGroup(ids, groupHash),
    ids,
    groupHash,
  },
});

export const bulkRemoveFromGroup = (ids, groupHash) => ({
  type: BULK_REMOVE_FROM_GROUP,
  payload: {
    promise: contactSvc.bulkRemoveFromGroup(ids, groupHash),
    ids,
    groupHash,
  },
});

export const bulkDelete = (ids) => ({
  type: BULK_DELETE,
  payload: {
    promise: contactSvc.bulkDelete(ids),
    ids,
  },
});

export const bulkRestore = (ids) => ({
  type: BULK_RESTORE_CONTACTS,
  payload: {
    promise: contactSvc.bulkRestore(ids),
    ids,
  },
});

export const mergeContacts = (contact1, contact2, props) => ({
  type: MERGE_CONTACT,
  payload: {
    promise: contactSvc.mergeContacts(contact1, contact2, props),
    contact1,
    contact2,
  },
});

export const getComments = (contactHash) => ({
  type: GET_COMMENTS,
  payload: {
    promise: contactSvc.getComments(contactHash),
    id: contactHash,
  },
});

export const addComment = (data) => ({
  type: ADD_COMMENT,
  payload: {
    promise: contactSvc.saveComment(data),
  },
});

export const deleteComment = (comment) => ({
  type: DELETE_COMMENT,
  payload: {
    promise: contactSvc.deleteComment(comment.hash),
    comment,
  },
});

export const updateComment = (payload) => ({
  type: EDIT_COMMENT,
  payload: {
    promise: contactSvc.saveComment(payload),
  },
});

export const loadCustomTabs = () => ({
  type: LOAD_CUSTOM_TABS,
  payload: {
    promise: contactSvc.getTabSections(),
  },
});

export const deleteCustomTab = (hash) => ({
  type: DELETE_CUSTOM_TAB,
  payload: {
    promise: contactSvc.deleteTabSection(hash),
    hash,
  },
});

export const createCustomTab = (data) => ({
  type: CREATE_CUSTOM_TAB,
  payload: {
    promise: contactSvc
      .saveTabSections(data)
      .then((res) => contactSvc.getTabSections({ hash: res.hash }))
      .then((res) => res[0]),
  },
});

export const updateCustomTab = (data) => ({
  type: UPDATE_CUSTOM_TAB,
  payload: {
    promise: contactSvc
      .saveTabSections(data)
      .then(() => contactSvc.getTabSections({ hash: data.hash }))
      .then((res) => res[0]),
  },
});
